// ============================================================================
// routerInstance.ts — ЕДИНСТВЕННЫЙ экземпляр роутера для навигации ВНЕ
// React-компонентов (initApp, selectBase, стора). Никаких фоллбэков:
// роутер обязан быть зарегистрирован до первого navigate — иначе ошибка.
// ============================================================================

import type { createBrowserRouter } from 'react-router-dom';

type RouterInstance = ReturnType<typeof createBrowserRouter>;

let _router: RouterInstance | null = null;

export function registerRouter(router: RouterInstance): void {
  _router = router;
}

export function getRouter(): RouterInstance {
  if (!_router) {
    throw new Error('routerInstance: роутер не зарегистрирован (registerRouter не вызван)');
  }
  return _router;
}
